import {brands} from '../../../brand/config'
import {BrandCode} from '../../../brand/types'

/**
 * Check if email OTP signup is enabled for a given brand and device type
 * @param isWebView - Whether the user is on a webview
 * @param brandCode - The brand code of the user
 * @returns True if email OTP signup is enabled, false otherwise
 */
export const isEmailOtpSignupEnabled = (
  isWebView: boolean,
  brandCode: BrandCode
) => {
  return brandCode === brands.vio.code && !isWebView
}
